namespace $ {

	$mol_style_define( $bog_wikilive_tree_node, {

		flex: {
			direction: 'column',
		},

		Row: {
			flex: {
				shrink: 0,
			},
		},

		Title: {
			flex: {
				grow: 1,
			},
			justify: {
				content: 'flex-start',
			},
		},

		Children: {
			padding: {
				left: '1rem',
			},
		},

	} )

}
